import { Controller } from 'stimulus';

const pad = (n) => String(n).padStart(2, '0');

export default class extends Controller {
  static values = { startedAt: String, alertAfter: Number };

  #timer;

  connect() {
    this.#tick();
    this.#timer = setInterval(() => this.#tick(), 1000);
  }

  disconnect() {
    clearInterval(this.#timer);
  }

  #tick() {
    const seconds = Math.max(0, Math.floor((Date.now() - new Date(this.startedAtValue)) / 1000));
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    this.element.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds % 60)}`;
    if (this.hasAlertAfterValue) {
      this.element.classList.toggle('is-long', seconds >= this.alertAfterValue);
    }
  }
}
